export function StatCard({ label, value, trend }) {
    return (
        <div className="bg-cs-surface border border-cs-border rounded-xl p-5">
            <p className="text-sm text-cs-muted">{label}</p>
            <p className="text-2xl font-semibold text-cs-dark mt-1">{value}</p>

            {trend !== undefined && (
                <p
                    className={`text-sm mt-2 ${trend >= 0 ? 'text-cs-success' : 'text-cs-danger'
                        }`}
                >
                    <i className={`fas ${trend >= 0 ? 'fa-arrow-up' : 'fa-arrow-down'}`} />
                    {' '} {trend}
                </p>
            )}
        </div>
    );
}
